import { http, HttpResponse } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import { vehicleOfflineSyncResponseMock } from '../data/vehicleDataMock';

const URL = `${BASE_URL_V3}${API.endpoints.tour}/:tourId/itinerary/:itineraryId${API.endpoints.sendToVehicle}`;

// 200: Vehicle is online, tour sent immediately (no body)
const sendToVehicleOnlineResponse = http.post(URL, () => {
    return new HttpResponse(null, { status: 200 });
});

// 202: Vehicle is offline, tour queued for deferred sync
const sendToVehicleOfflineResponse = http.post(URL, () => {
    return HttpResponse.json(vehicleOfflineSyncResponseMock, { status: 202 });
});

const sendToVehicleErrorResponse = http.post(URL, () => {
    return HttpResponse.error();
});

export const sendToVehicleResponse = {
    success: sendToVehicleOnlineResponse,
    offline: sendToVehicleOfflineResponse,
    error: sendToVehicleErrorResponse,
};
